module.exports = __webpack_public_path__ + "img/e442fed.jpg";